import HeartGrayIcon from '@assets/images/app/btn-heart-gray.png';
import HeartRedIcon from '@assets/images/app/btn-heart-red.png';
import LiveIcon from '@assets/images/app/icon-live-16@3x.png';
import LocationIcon from '@assets/images/app/icon-location-16@3x.png';
import { ProductActivityType, ProductModel, PRODUCT_ACTIVITY_TYPE_TEXT } from '@models/product';
import { getAddressText } from '@utils/dataTransform';
import { cdnImageUrl } from '@utils/image';
import React from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import { ReactComponent as StarOn } from '@assets/images/app/star-pink.svg';

interface ProductItemProps {
  item?: ProductModel;
  isFavorited?: boolean;
  style?: any;
  width?: number;
  distance?: number;
  onClick?: (event: any) => void;
}

export const ProductItem: React.FC<ProductItemProps> = (props) => {
  const _renderItemImage = (imageUrl: string) => {
    const isFavorited = props.isFavorited;

    const fixImageUrl = imageUrl;

    const addressText = getAddressText({
      activityType: props.item?.activityType,
      availableArea: props.item?.location,
    });

    return (
      <div style={{ width: '100%', borderRadius: '8px', overflow: 'hidden' }}>
        <img
          style={{
            width: '100%',
            borderRadius: '8px',
            objectFit: 'cover',
            aspectRatio: 1,
          }}
          src={cdnImageUrl(fixImageUrl)}></img>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.6)',
            paddingLeft: '4px',
            paddingRight: '6px',
            height: '20px',
            borderRadius: '4px',
            position: 'absolute',
            top: '8px',
            left: '8px',
          }}>
          <img
            src={props.item?.activityType === ProductActivityType.ONLINE ? LiveIcon : LocationIcon}
            style={{ alignSelf: 'center', width: '14px', height: '14px', marginRight: '2px' }}></img>
          <div
            style={{
              alignSelf: 'center',
              fontSize: '11px',
              color: '#ffffff',
              fontWeight: 500,
              lineHeight: '10px',
            }}>
            {addressText == '전체' ? '전체' : addressText}
          </div>
        </div>
        {isFavorited && (
          <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
            <img
              style={{
                width: '24px',
                height: '24px',
                border: '1px solid #d8d8d8',
                borderRadius: '50%',
              }}
              src={isFavorited ? HeartRedIcon : HeartGrayIcon}
            />
          </div>
        )}
      </div>
    );
  };

  const item = props.item;
  const mainImageUrl = item?.thumbnailImage;
  const hasReview = item?.statistics?.reviewCount !== undefined && item?.statistics?.reviewCount > 0;
  const applyGroupDiscount = item?.applyGroupDiscount;

  return (
    <div id="class-item" style={{ ...props.style, position: 'relative' }} onClick={props.onClick}>
      {mainImageUrl && _renderItemImage(mainImageUrl as string)}
      <div style={{ marginTop: '10px' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          {props.item?.activityType && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <div
                style={{
                  fontSize: '12px',
                  textAlign: 'center',
                  color: '#808387',
                  fontWeight: 'bold',
                  marginRight: '4px',
                  lineHeight: '16px',
                }}>
                {PRODUCT_ACTIVITY_TYPE_TEXT[props.item?.activityType]?.title}
              </div>
              <div style={{ width: '1px', height: '8px', backgroundColor: '#d8d8d8', marginRight: 4 }}></div>
              <div
                style={{
                  fontSize: '12px',
                  textAlign: 'left',
                  color: '#808387',
                  fontWeight: 'normal',
                  lineHeight: '16px',
                }}>
                {props.item.sellerName}
              </div>
            </div>
          )}
          {props.distance !== undefined && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                flexShrink: 0,
              }}>
              <div
                style={{
                  width: '1px',
                  height: '8px',
                  backgroundColor: '#d8d8d8',
                  marginRight: '4px',
                  marginLeft: '4px',
                }}
              />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}>
                <div>
                  <div
                    style={{
                      fontSize: '12px',
                      textAlign: 'center',
                      color: '#808387',
                    }}>
                    {`${(props.distance / 1000).toFixed(1)}km`}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          letterSpacing: -0.2,
          marginTop: '6px',
          flex: 1,
          fontSize: '14px',
          color: '#424242',
          lineHeight: '18px',
          maxHeight: '36px',
          overflow: 'hidden',
        }}>
        <LinesEllipsis text={props.item?.title} maxLine={2} ellipsis="..." trimRight></LinesEllipsis>
      </div>
      <div style={{ alignItems: 'flex-start', alignContent: 'flex-start', flexDirection: 'column', marginTop: 6 + 2 }}>
        {
          <div
            style={{
              fontWeight: 'bold',
              fontSize: '14px',
              color: '#242424',
              lineHeight: '18px',
            }}>
            {(props.item?.fee || 0).toLocaleString()}원{' '}
            {props.item && props.item.regularTime && props.item.regularTime > 0 ? ` / ${props.item.regularTime}회` : ''}
          </div>
        }
      </div>

      {(hasReview || applyGroupDiscount) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          {hasReview && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
              <StarOn width={14} height={14} />
              <div
                style={{
                  overflow: 'hidden',
                  color: '#424242',
                  textOverflow: 'ellipsis',
                  fontFamily: 'Pretendard',
                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                }}>
                {item?.statistics?.reviewRating && Math.floor(item?.statistics?.reviewRating * 10) / 10}
              </div>
              <div
                style={{
                  overflow: 'hidden',
                  color: '#808387',
                  textOverflow: 'ellipsis',
                  fontFamily: 'Pretendard',
                  fontSize: '12px',
                  fontStyle: 'normal',
                  fontWeight: 500,
                }}>
                ({item?.statistics?.reviewCount?.toLocaleString()})
              </div>
            </div>
          )}
          {hasReview && applyGroupDiscount && (
            <svg xmlns="http://www.w3.org/2000/svg" width="2" height="3" viewBox="0 0 2 3" fill="none">
              <circle cx="1" cy="1.5" r="1" fill="#D9D9D9" />
            </svg>
          )}
          {applyGroupDiscount && (
            <div
              style={{
                color: '#F03F45',
                textAlign: 'center',
                fontFamily: 'Pretendard',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 500,
              }}>
              그룹할인
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductItem;
